import React, { useEffect } from 'react';
import { ChevronLeft, X } from 'lucide-react';
import FeatureFlagDetails from './FeatureFlagDetails';

const FeatureFlagModal = ({ flag, isOpen, onClose, onUpdate }) => {
  useEffect(() => {
    document.body.style.overflow = isOpen ? 'hidden' : 'unset';
    return () => { document.body.style.overflow = 'unset'; };
  }, [isOpen]);

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === 'Escape' && isOpen) onClose();
    };
    if (isOpen) document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);

  if (!isOpen || !flag) return null;

  return (
    <div
      className="fixed inset-0 bg-black/60 z-[10000] flex items-start justify-center overflow-y-auto lg:hidden"
      onClick={onClose}
      role="presentation"
    >
      <div
        className="bg-white dark:bg-slate-900 w-full min-h-screen flex flex-col"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 z-10 flex justify-between items-center p-4 border-b border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 shadow-sm">
          <div className="flex items-center gap-2 flex-1 min-w-0">
            <button
              onClick={onClose}
              aria-label="Back"
              className="hidden md:flex items-center gap-2 px-3 py-2 bg-blue-50 dark:bg-blue-950 text-blue-600 rounded-lg font-semibold hover:bg-blue-100 dark:hover:bg-blue-900"
            >
              <ChevronLeft size={20} />
              Back
            </button>
            <h2 className="text-lg font-semibold text-gray-900 dark:text-gray-100 truncate">Feature Flag Details</h2>
          </div>
          <button
            onClick={onClose}
            aria-label="Close"
            className="p-2 text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-700 rounded-lg md:hidden"
          >
            <X size={24} />
          </button>
        </div>
        <div className="flex-1 p-4 pb-20 overflow-y-auto">
          <FeatureFlagDetails flag={flag} onUpdate={onUpdate} />
        </div>
        <div className="sticky bottom-0 p-4 border-t border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-900 md:hidden">
          <button
            onClick={onClose}
            className="w-full py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default FeatureFlagModal;
